// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".duro{flex:1;text-align:center;overflow:hidden;max-width:432px;min-width:432px}\n", ""]);
// Exports
module.exports = exports;
